export { BSModalContext, BSModalContextBuilder } from './modal-context';
export { BSModalContainer } from './modal-container.component';
export { BSMessageModal, BSMessageModalTitle, BSMessageModalBody, BSModalFooter } from './message-modal.component';
export { MessageModalPresetBuilder } from './presets/message-modal-preset';
export { ModalOpenContext, ModalOpenContextBuilder } from 'angular2-modal';
export { OneButtonPresetBuilder } from './presets/one-button-preset';
export { TwoButtonPresetBuilder, PromptPresetBuilder } from './presets/two-button-preset';
export { Modal } from './modal';
export { BootstrapModalModule, providers } from './bootstrap.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-modal/plugins/bootstrap/index.js
// module id = 10
// module chunks = 3